// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IQrCodePresignUrlRequestDto
 */
export interface IQrCodePresignUrlRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IQrCodePresignUrlRequestDto
     */
    qr_id: string;
    /**
     * 
     * @type {string}
     * @memberof IQrCodePresignUrlRequestDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IQrCodePresignUrlRequestDto
     */
    employee_id: number;
}

/**
 * Check if a given object implements the IQrCodePresignUrlRequestDto interface.
 */
export function instanceOfIQrCodePresignUrlRequestDto(value: object): value is IQrCodePresignUrlRequestDto {
    if (!('qr_id' in value) || value['qr_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function IQrCodePresignUrlRequestDtoFromJSON(json: any): IQrCodePresignUrlRequestDto {
    return IQrCodePresignUrlRequestDtoFromJSONTyped(json, false);
}

export function IQrCodePresignUrlRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQrCodePresignUrlRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'qr_id': json['qr_id'],
        'name': json['name'],
        'employee_id': json['employee_id'],
    };
}

export function IQrCodePresignUrlRequestDtoToJSON(json: any): IQrCodePresignUrlRequestDto {
    return IQrCodePresignUrlRequestDtoToJSONTyped(json, false);
}

export function IQrCodePresignUrlRequestDtoToJSONTyped(value?: IQrCodePresignUrlRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qr_id': value['qr_id'],
        'name': value['name'],
        'employee_id': value['employee_id'],
    };
}

